import { ComponentsOverrides, Theme } from '@mui/material';

export const getMuiDialogOverrides = (theme: Theme): ComponentsOverrides['MuiDialog'] => ({
  root: {
    zIndex: 999,
  },
});
